import { useCallback } from "react";
import useStore from "../store";

export const useNodeDataUpdate = () => {
  const nodes = useStore((state) => state.nodes);
  const setNodes = useStore((state) => state.setNodes); // 不会触发onNodesChange

  const handleNodeDataUpdate = useCallback(
    ({ id, data }) => {
      const newNodes = nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              ...data,
            },
          };
        }
        return node;
      });
      setNodes(newNodes);
    },
    [nodes, setNodes]
  );

  return {
    handleNodeDataUpdate,
  };
};
